import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '7px',
    cursor: 'default'
  },

  avatar: {
    width: 20,
    height: 20,
    marginRight: '0.2rem',
    fontSize: theme.size.sm,
    backgroundColor: ({ noUser }) => noUser && 'lightgray'
  },

  title: {
    marginLeft: '10px',
    fontSize: theme.size.sm,
    color: '#323436'
  },

  faded: {
    color: 'inherit',
    opacity: '0.35'
  },

  noUser: {
    color: 'lightgrey',
    cursor: 'default'
  },
  noPermission: {
    display: 'flex',
    '& .warn': {
      color: '#B8960C',
      cursor: 'pointer',
      marginLeft: '0.5rem'
    }
  }
}))

export default useStyles
